'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');let

DeleteUserModalController=(_dec=




















HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(DeleteUserModalController,_BaseController);_createClass(DeleteUserModalController,null,[{key:'$inject',get:function(){return['$modalInstance','uncaughtErrorHandler','user','onUserDeleted','socketService','uiCommandFactory','notificationService']}}]);function DeleteUserModalController($modalInstance,uncaughtErrorHandler,user,onUserDeleted,socketService,uiCommandFactory,notificationService){_classCallCheck(this,DeleteUserModalController);_.ensureInstanceOf(UserInfo,user);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$modalInstance=$modalInstance;_this._user=user;_this._onUserDeleted=onUserDeleted;_this._socketService=socketService;_this._notificationService=notificationService;_this._deleteUserCommand=uiCommandFactory.makeForModal($modalInstance,_this._deleteUser.bind(_this));return _this}DeleteUserModalController.prototype.
_deleteUser=function(){var ref=_asyncToGenerator(function*(){
let deleteResult=yield this._socketService.sendAndWaitForResponse('DeleteUser',{id:this._user.id.toString()});

if(!SocketResponse.succeeded(deleteResult)){
let message='There was an error deleting the user.';

if(deleteResult.status==='CannotDeleteSelf'){
message='You cannot delete yourself.';
}

if(deleteResult.status==='HttpError'){
if(deleteResult.body.httpStatus===403){
message='You cannot delete the primary user.';
}else if(deleteResult.body.httpStatus===404){
message='The user was not found, could not delete user.';
}
}

this._notificationService.displayNotification(message,'error');

return ModalSubmissionResult.Close();
}

this._notificationService.displayNotification('User successfully deleted.','success');

yield this._onUserDeleted();

return ModalSubmissionResult.Close();
});function _deleteUser(){return ref.apply(this,arguments)}return _deleteUser}();DeleteUserModalController.prototype.





onCancel=function onCancel(){
this._$modalInstance.dismiss();
};_createClass(DeleteUserModalController,[{key:'deleteUserCommand',get:function(){return this._deleteUserCommand}},{key:'user',get:function(){return this._user}}]);return DeleteUserModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_deleteUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_deleteUser'),_class.prototype)),_class));


module.exports=DeleteUserModalController;
//# sourceMappingURL=deleteUserModalController.js.map
